export default function SectionTitle({ children, variant = 'default', number }) { return <h2 className={`document-section-title document-section-title--${variant}`}>{number && <span>{number}</span>}{children}</h2>; }
